import { Map } from 'immutable';
import { types as orgActionTypes } from '@saucelabs/sl-module-organization';

import * as types from './types';

const initialState = Map({
  config: Map(),
  globalAvailable: true,
  loading: false,
  loadingGlobal: false,
  migrationStatus: '',
  metadata: Map(),
});

const ssoReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.GET_SSO_METADATA.REQUEST:
      return state.set('loading', true);
    case types.GET_SSO_METADATA.FAILURE:
      return state.set('loading', false);
    case types.GET_SSO_METADATA.SUCCESS:
    case types.UPDATE_SSO_METADATA.SUCCESS:
      return state.withMutations((newState) => {
        newState
          .set('metadata', Map(payload))
          .set('loading', false);
      });
    case types.DELETE_SSO_METADATA.SUCCESS:
      // Temporary change from resetting to initialState, as both global
      // and legacy sso need to use one reducer.
      return state.withMutations((newState) => {
        newState
          .set('metadata', initialState.get('metadata'))
          .set('loading', initialState.get('loading'));
      });

    // State connected to Global SSO managed via sso-service.
    case types.GET_SSO_CONFIG.REQUEST:
      return state.set('loadingGlobal', true);
    case types.GET_SSO_CONFIG.FAILURE:
      return state.set('loadingGlobal', false);
    case types.GET_SSO_CONFIG.SUCCESS:
    case types.UPDATE_SSO_CONFIG.SUCCESS:
    case types.DELETE_SSO_CONFIG.SUCCESS:
      return state.withMutations((newState) => {
        newState
          .set('config', Map(payload))
          .set('loadingGlobal', false);
      });
    case types.CHECK_SSO_CONFIG_AVAILABLE.SUCCESS: {
      return state.withMutations((newState) => {
        newState
          .set('migrationStatus', payload?.status || '')
          .set('globalAvailable', true);
      });
    }
    case types.CHECK_SSO_CONFIG_AVAILABLE.FAILURE:
      return state.withMutations((newState) => {
        newState
          .set('migrationStatus', '')
          .set('globalAvailable', false);
      });

    case orgActionTypes.PATCH_US_SSO_SETTINGS.SUCCESS:
      if ('sso_only' in payload) {
        return state.withMutations((newState) => {
          newState
            .setIn(['config', 'sso_only'], payload.sso_only);
        });
      }

      return state;

    default:
      return state;
  }
};

export default ssoReducer;
